import { Box, Button, LinkButton } from "@bca/ui-library";
import { Devices, useViewport } from "../Hooks/useViewport.hook";
import payNowDataPush from "../AdobeDataPushes/invoiceModal/payNowDataPush";
import { Vehicle } from "../Interfaces/vehicle.type";
import LeftArrow from "../Icons/LeftArrow";

interface PayInvoiceButtonProps {
  vehicleData?: Vehicle;
  invoiceData?: any;
  openBankingLinkUrl?: string;
  onClose: () => void;
}

const PayInvoiceButton: React.FunctionComponent<PayInvoiceButtonProps> = ({
  vehicleData = {} as Vehicle,
  invoiceData = {},
  openBankingLinkUrl = null,
  onClose,
}) => {
  const payNowAnalytics = () =>
    payNowDataPush(
      vehicleData,
      invoiceData?.netAmount,
      invoiceData?.invoiceNumber
    );

  const viewportWidth = useViewport();
  return (
    <Box
      justifyContent="flex-end"
      width="auto"
      display="flex"
      flexDirection={{
        mobile: "column-reverse",
        desktop: "row",
      }}
    >
      {viewportWidth !== Devices.DESKTOP && (
        <Button
          marginTop={{
            mobile: "16px",
            desktop: "0px",
          }}
          marginRight={{
            mobile: "0px",
            desktop: "16px",
          }}
          width={{
            mobile: "100%",
            desktop: "167px",
          }}
          variant="secondary"
          height="42px"
          onClick={onClose}
          fontSize="body-small"
        >
          Close
        </Button>
      )}
      {openBankingLinkUrl && (
        <LinkButton
          shouldOpenInNewWindow={true}
          fontSize="body-small"
          variant="primary"
          link={openBankingLinkUrl}
          onClick={payNowAnalytics}
          height="42px"
          paddingX="19px"
          width={{
            mobile: "100%",
            desktop: "167px",
          }}
        >
          Pay Now
          <Box display="flex" paddingLeft="11px">
            <LeftArrow width={18} height={18} />
          </Box>
        </LinkButton>
      )}
    </Box>
  );
};

export default PayInvoiceButton;
